import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IconButton, Popover} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import Done from "@material-ui/icons/DoneOutlined";
import Cancel from "@material-ui/icons/ClearOutlined";
import AdminPartnersFilter from "../../../common/filters/AdminPartnersFilter";
import MaterialUISelect from "../../../common/selects/MaterialUISelect";
import {sort} from "../../../../utils/sortUtils";
import {saveOrUpdateCapItem, setNeedToReloadCapItems} from "../../../../actions/capItemActions";

export default function CapItemPopover({button, capItem}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const dispatch = useDispatch();
    let capServices = useSelector(state => state.capServiceGroupReducer.capServiceGroups);
    const {partnerGroups} = useSelector(state => state.filterDataReducer.filterData);
    capServices = capServices && sort(capServices, "name", 1);


    const [selectedPartners, setSelectedPartners] = useState([]);
    const [editableCapItem, setEditableCapItem] = useState({});
    const [selectedCapService, setSelectedCapService] = useState(null);

    useEffect(() => {
        if (!capItem || !anchorEl || !capServices) {
            return;
        }
        setEditableCapItem(capItem);
        const partners = capItem.partners?.map(partner => {return {...partner, partnerName : partner.name, dominicPartnerId : partner.externalId}})
        setSelectedPartners(partners);
        setSelectedCapService({id: capItem?.capServiceId, name: capItem?.capServiceName});
    }, [capItem, anchorEl]);



    const handleClick = (e) => {

        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const saveOrUpdate = () => {
        const capItem = {
            id: editableCapItem?.id,
            capServiceGroup: { id: selectedCapService?.id, name: selectedCapService?.name },
            partnerIds: selectedPartners?.flatMap(partner => !partner.isGroup
                ? [partner.dominicPartnerId]
                : partnerGroups.find(group => group.partnerTypeId === partner.partnerTypeId)?.options.map(partner => partner.dominicPartnerId)
            ),
            maxLimit: editableCapItem?.maxLimit,
        }

        dispatch(saveOrUpdateCapItem(capItem, () => dispatch(setNeedToReloadCapItems())));
        handleClose();
    };

    const popover = () => {
        return (
            <Popover id={id}
                     open={open}
                     anchorEl={anchorEl}
                     onClose={handleClose}
                     anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'right',
                     }}
                     transformOrigin={{
                         vertical: 'top',
                         horizontal: 'right',
                     }}
            >
                <div style={{padding: "10px", textAlign: "center"}}>
                    {editableCapItem?.id ? "Редактировать" : "Создать"}
                </div>
                <div style={{padding: "10px", minWidth: "305px", maxWidth: "500px", maxHeight: "90vh", overflowY: "auto"}}>
                    <AdminPartnersFilter selectedPartners={selectedPartners}
                                         handleChangeFilterData={setSelectedPartners}
                     inputStyle={{paper: {maxHeight: 250, position: "relative"}}}/>
                    <MaterialUISelect
                                      dropdownData={capServices}
                                      selectedValue={selectedCapService}
                                      displayedField='name'
                                      dataField='id'
                                      label='CAP сервис'
                                      onSelectCallbackFunction={setSelectedCapService}
                                      isSearchable/>
                    <TextField label="Лимит"
                               name="maxLimit"
                               value={editableCapItem?.maxLimit || ""}
                               onChange={(e) => setEditableCapItem({...editableCapItem, maxLimit : e.target.value})}
                               InputLabelProps={{shrink: true}}
                               style={{width: '100%', paddingBottom: '15px'}}
                    />
                    <br/>
                    <br/>
                    <div className="text-right">
                        <IconButton disableFocusRipple size="medium" onClick={saveOrUpdate}
                                    variant="contained"
                                    title="Сохранить параметр">
                            <Done fontSize="medium"/>
                        </IconButton>
                        <IconButton disableFocusRipple size="medium" onClick={handleClose} variant="contained"
                                    title="Отмена">
                            <Cancel fontSize="medium"/>
                        </IconButton>
                    </div>
                </div>
            </Popover>
        )
    };

    return (
        <>
            <div className="" onClick={handleClick}>
                {button}
            </div>
            {anchorEl && popover()}
        </>
    );}